import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=4b8511bf&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b8511bf')) {
      api.createRecord('4b8511bf', component.options)
    } else {
      api.reload('4b8511bf', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=4b8511bf&", function () {
      api.rerender('4b8511bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-47nv6WJ24rFeb/JS/comp/IncreaseNumber.vue"
export default component.exports